// pdf.js 4.4+ uses Promise.withResolvers (ES2024), unavailable on older browsers.
// Loaded as a webpack entry point (see craco.config.js) so it runs before any app code.
if (typeof Promise.withResolvers !== 'function') {
  // eslint-disable-next-line no-extend-native
  Promise.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
